import CvSectionTemplate from './CvSectionTemplate';

export default function CvAchievements() {
  return (
    <CvSectionTemplate
      currentId="check_2"
      description="Wymień swoje wyróżnienia, nagrody lub inne znaczące sukcesy zawodowe."
    />
  );
}
